/* eslint-disable max-len */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '../../base/Typography';

import {
  ULStyled,
  LIStyled,
  IconStyled,
  TypographyListItemHeader,
} from './styles';

export const BulletedListComponent = ({
  bulletedListData,
}) => {
  useEffect(() => {
    // validate all bulletedListData passed in are correct
    if (bulletedListData.length === 0) {
      console.error('Missing bulleted list data. At least one entry is required.');
    }
  }, []);
  return (
    <ULStyled>
      {bulletedListData.map((item, index) => (
        <LIStyled key={index}>
          <IconStyled />
          {item.bulletedHeader && (
            <TypographyListItemHeader
              component='h5'>
              {item.bulletedHeader}
            </TypographyListItemHeader>
          )}
          {item.bulletedCopy && (
            <Typography
              component='p'>
              {item.bulletedCopy}
              {item.sup && (<sup>{item.sup}</sup>)}
            </Typography>
          )}
        </LIStyled>
      ))}
    </ULStyled>
  );
};

BulletedListComponent.propTypes = {
  /** Array of accoladed to display in the section */
  bulletedListData: PropTypes.arrayOf(PropTypes.shape({
    /** The 'id' of the accolade wanting to display */
    bulletedHeader: PropTypes.string,
    /** The sup number corresponding with the footer reference, Required for bulletedListData needing source to cite */
    bulletedCopy: PropTypes.any,
  })).isRequired,
};

export default BulletedListComponent;
